import ExaminationManagement from './ExaminationManagement';

export default ExaminationManagement;
